import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { BudgetActionSearchProvider } from './context/budget-action-search-context';
import { BudgetActionSearchComponent } from './budget-action-search-component';

export function BudgetActionSearchFactory() {
    return (
        <BaseLayoutFactory>
            <BudgetActionSearchProvider>
                <BudgetActionSearchComponent />
            </BudgetActionSearchProvider>
        </BaseLayoutFactory>
    );
}
